import {
    get
} from "@/common/request"

export function GetFooterData() {
    return get("footer/get")
}